module.exports = "/_next/static/images/scanner-2873608821b456ee494a0ca0557f6ba2.png";